<div
  class="wrapper relative justify-between rounded-(--radius-md) w-[355px] bg-(--surface-2) min-h-[140px] h-full flex flex-col gap-(--gap-relaxed) p-(--padding-card) border-1 border-(--border) hover:border-gray-400 hover:shadow-sm transition-[border-color,box-shadow] duration-150"
  [class]="wrapperClass()"
  [attr.role]="clickable() && !href() ? 'button' : null"
  [attr.tabindex]="clickable() && !href() ? 0 : null"
  (click)="clickable() && !href() ? clickAction($event) : null"
  (keydown.enter)="clickable() && !href() ? clickAction($event) : null"
  (keydown.space)="clickable() && !href() && clickAction($event)">
  @if (href()) {
    <a
      class="link-overlay absolute inset-0 z-1 opacity-0 rounded-(--radius-md)"
      [attr.href]="href()"
      [attr.aria-label]="title()"
      (click)="onLinkClick($event)"></a>
  }
  <div class="flex flex-row justify-between">
    <ng-container *ngTemplateOutlet="titleTemplate || defaultTitle" />
    <div class="relative z-2">
      <ng-container *ngTemplateOutlet="actionTemplate || defaultAction" />
    </div>
  </div>
  <div class="grow-1">
    <ng-container *ngTemplateOutlet="bodyTemplate || defaultBody" />
  </div>
  <div class="relative z-2">
    <ng-container *ngTemplateOutlet="footerTemplate || defaultFooter" />
  </div>
</div>

<ng-template #defaultTitle>
  <div class="text-lg font-semibold text-(color:--text-primary) truncate line-clamp-1">{{ title() }}</div>
</ng-template>

<ng-template #defaultAction>
  <div class="flex flex-row gap-(--gap-normal)">
    @if (items(); as menuItems) {
      @if (menuItems.length) {
        <div>
          <ces-menu-button-secondary [items]="menuItems" size="small" icon="more_vert" />
        </div>
      }
    }
    <ces-button
      size="small"
      icon="arrow_forward"
      (onClick)="clickAction($event)"
      class="main-button"
      [hasPermission]="hasPermission()" />
  </div>
</ng-template>

<ng-template #defaultBody>
  <div class="flex flex-col text-base">
    <div class="line-clamp-1">{{ bodyTitle() }}</div>
    <div class="text-(color:--text-secondary) line-clamp-1">{{ bodyDescription() }}</div>
  </div>
</ng-template>

<ng-template #defaultFooter>
  {{ footer() }}
</ng-template>
